<template>
<div>

<div class="contenttopbar grid px-3 mt-1">

<div class="col-9 md:col-8">
<h3 class="text-primary mb-3 mt-3 font-medium">{{$store.state.languages.lang_phrases.marka_raporlari}}</h3>
</div>

<div class="col-3 md:col-4">
<div class="flex align-items-center justify-content-end">

<div class="hide_on_mobile "><Button type="button" class="p-button-primary p-button-outlined p-button-sm mt-2 mr-2" :label="$store.state.languages.lang_phrases.yeni_grup_ekle" icon="pi pi-sitemap" @click="addNewGroup" /></div>
<div class="show_on_mobile"><Button type="button" class="p-button-primary p-button-outlined p-button-sm mt-2 mr-2" icon="pi pi-sitemap" @click="addNewGroup" /></div>

<div class="hide_on_mobile "><Button type="button" class="p-button-primary p-button-outlined p-button-sm mt-2" :label="$store.state.languages.lang_phrases.yeni_ekle" icon="pi pi-plus" @click="addNew" /></div>
<div class="show_on_mobile"><Button type="button" class="p-button-primary p-button-outlined p-button-sm mt-2" icon="pi pi-plus" @click="addNew" /></div>


</div>
</div>
</div> 












<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">

<!--groups-->
<div class="grid py-0">
<div class="col-12 pb-0"><h3 class="text-primary mt-4 mb-0">{{$store.state.languages.lang_phrases.rapor_gruplari}}</h3></div>
<div class="col-12"><hr></div>

<div class="col-12 " v-if="!groups.length">
<div class="flex align-items-center justify-content-center mb-2 mt-2">
<h3 class="text-primary font-medium">{{$store.state.languages.lang_phrases.henuz_hic_kayit_olusturulmamis}}</h3>
</div>
</div>

<div class="col-12 " v-else>
<draggable 
v-model="groups"
data_container_id="groups"
class="list-group" 
group="grouped"  
@change="changeGroups"
v-bind="dragOptions"
item-key="id"> 
<template #item="{element}">
<BrandVisualGroupLine :group="element" @groupdeleted="groupdeleted"/>
</template>
</draggable>

</div>


</div>
<!--groups-->





<template v-if="items.length==0">
<div class="flex align-items-center justify-content-center mb-8 mt-8">
<h3 class="text-primary font-medium">{{$store.state.languages.lang_phrases.henuz_hic_kayit_olusturulmamis}}</h3>

</div>
</template>
<template v-else>


<hr>
<h3 class="text-primary mt-4 mb-0">{{$store.state.languages.lang_phrases.gruplanmamis_raporlar}}</h3>
<draggable 
v-model="items"
data_container_id="ungrouped"
class="list-group" 
group="ungrouped" 
@start="start" 
@end="end" 
@change="change"
v-bind="dragOptions"
item-key="id">
<template #item="{element}">
<BrandReportLine :report="element" />
</template>
</draggable>


<!--
<div class="mt-4">
<DataTable :value="items" 
responsiveLayout="scroll" 
stripedRows 
class="p-datatable-sm" 
>

<Column  :header="$store.state.languages.lang_phrases.isim" >
<template #body="slotProps">
  <template v-if="slotProps.data.translations.length">
    <router-link  
    v-for="translation in slotProps.data.translations"
    v-show="translation.language_id == $store.state.auth.user.preflang_id"
    class="text-primary p-link no-underline" 
    :to="{ name: 'BrandReport' , params: {report_id:slotProps.data.id}}"
    >{{ translation.translation}}</router-link>
  </template>
  <template v-else>
    <router-link  class="text-primary p-link no-underline" :to="{ name: 'BrandReport' , params: {report_id:slotProps.data.id}}">{{ slotProps.data.name}}</router-link>
  </template>

</template>
</Column>

<Column  :header="$store.state.languages.lang_phrases.rapor_guncellendi">
<template #body="slotProps">
<ReportProgersssBar :data="slotProps.data"></ReportProgersssBar>
</template>
</Column>
<Column   :header="$store.state.languages.lang_phrases.eklenme_tarihi" >
<template #body="slotProps">
<p>{{ $filters.momentFormat( slotProps.data.created_at," Do-MM-YYYY HH:mm")}}</p>
</template>
</Column>

<Column   :header="$store.state.languages.lang_phrases.guncelleme_tarihi" >
<template #body="slotProps">
<p>{{ $filters.momentFormat( slotProps.data.updated_at," Do-MM-YYYY HH:mm")}}</p>
</template>
</Column>

<Column headerStyle="width: 4rem; text-align: center" bodyStyle="text-align: center; overflow: visible" class="">
<template #body="slotProps">
 <Button type="button"  icon="pi pi-ellipsis-h" @click="toggle($event,slotProps.data.id)" aria-haspopup="true" :aria-controls="'overlay_menu'+slotProps.data.id" class="p-button-primary p-button-text p-button-sm mt-1"   />
<Menu :id="'overlay_menu'+slotProps.data.id" :ref="'menu'+slotProps.data.id" :model="menuitems" :popup="true">
 <template #item="{item}">  
  <template v-if="item.label=='Sil'">
      <a class="p-menuitem-link" 
      role="menuitem" 
      @click="item.command(item.argument,{report_id:slotProps.data.id})"
      >
      <span :class="'p-menuitem-icon '+item.icon"></span>
      <span class="p-menuitem-text">{{item.label}}</span>
      <span class="p-ink"></span></a>
  </template>
  <template v-else>
    <a class="p-menuitem-link" 
      role="menuitem" 
      @click="item.command(item.argument,{report_id:slotProps.data.id})"
      >
      <span :class="'p-menuitem-icon '+item.icon"></span>
      <span class="p-menuitem-text">{{item.label}}</span>
      <span class="p-ink"></span></a>
  </template>

</template>
</Menu>
</template>
</Column>


</DataTable>








</div>

-->

</template>






</template>


</div>	
</template>

<script>
export default {

  name: 'BrandReports',
  data () {
    return {
      items:[],
      groups:[],
      drag:false,
      menuitems: [
        {
                label: this.$store.state.languages.lang_phrases.goruntule,
                icon: 'pi pi-eye',
                argument:this.routename,
                command: (argument,id) => {
                  console.log(argument)
                  console.log(id)
                  //return false
                     this.gotoPage("BrandReport",id)
                  }
            },
            {
                label: this.$store.state.languages.lang_phrases.sil,
                icon: 'pi pi-trash',
                argument:this.deleteobjectname,
                command: (argument,id) => {
                  console.log(argument)
                  console.log(id)
                  //return false
                     this.deleteItem("brand_report",id)
                  }
            },

      ],
      loading:true,
      columns:[
        {
          type:"text",
          field:"name",
          header:"isim",
          hide_on_mobile:false,
        },        
        {
          type:"boolean",
          field:"is_uptodate",
          header:"rapor_guncellendi",
          hide_on_mobile:false,
        },      
        {
          type:"slider",
          field:"id",
          header:"rapor_guncellendi",
          hide_on_mobile:false,
        },
        {
          type:"date",
          field:"created_at",
          header:"eklenme_tarihi",
          hide_on_mobile:true,
        },
        {
          type:"date",
          field:"updated_at",
          header:"guncelleme_tarihi",
          hide_on_mobile:true,
        },
        ]
    }
  },
  computed:{
    deletedstate()
    {
      return this.$store.state.ui.deletedstate
    },
    dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  watch:{
    deletedstate(newVal,oldVal)
    {
      if(newVal)
      {
        this.getData()
      }
    }
  },
  mounted()
  {
    this.getData()
  },
  methods:{
    groupdeleted(id)
    {
      this.getData()
    },
    changeGroups()
    {
      let formdata = new FormData()
      let list = this.groups.map(item=>item.id)
      formdata.append("list",JSON.stringify(list))
      this.silentSubmission(formdata,"reorder_report_groups",this.afterChange)
    },
    change(event)
    {
      console.log("ungrouped")
      console.log(this.items)
      let formdata = new FormData()
      let list = this.items.map(item=>item.id)
      formdata.append("list",JSON.stringify(list))
      this.silentSubmission(formdata,"reorder_group_reports/ungrouped",this.afterChange)

    },
    afterChange(response)
    {

    },
    end(event)
    {
      this.drag = false
    },
    start(event)
    {
      this.drag = true
    },

    addNew()
    {
      this.$router.push({ name: "NewBrandReport"})
    },
    addNewGroup()
    {
      this.$router.push({ name: "CreateBrandReportVisualGroup"})
    },    
    toggle(event,id) {
      
      //return false
        this.$refs['menu'+id].toggle(event);
    },
    async getData()
    {
      //let items = await this.generalApiGetWithoutLoader("brand_reports/"+this.$route.params.id)
      this.items = await this.generalApiGetWithoutLoader("ungrouped_brand_reports/"+this.$route.params.id)
      this.groups = await this.generalApiGetWithoutLoader("brand_report_groups/"+this.$route.params.id)
      
      //this.items = await items
      console.log(this.items)
      this.loading = await false
    }
  }
}
</script>

<style lang="css" scoped>

</style>